// extracted by mini-css-extract-plugin
export default {"canvas":"Canvas_canvas__G-Vuv"};